module.exports = __webpack_public_path__ + "assets/01.8259c4ea.pdf";